"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.object.assign.js");
var _utils = require("../utils");
var _fixTop = _interopRequireDefault(require("../mixins/fix-top"));
var _use = (0, _utils.use)('fix-top'),
  sfc = _use[0],
  bem = _use[1];
var _default2 = sfc({
  mixins: [_fixTop.default],
  props: {
    zIndex: {
      type: Number,
      default: 50 // 设计上应小于 simple-sticky
    },

    keepPosition: Boolean,
    enableFadeIn: {
      type: Boolean,
      default: false
    },
    enableClientRect: {
      type: Boolean,
      default: false
    },
    fadeInStart: {
      type: Number,
      default: 0 // 触发渐现的起始页面滚动高度
    },

    // 样式对象，透传给 z-fix-top--fixed 的 style 属性。
    headerTaskbarStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /**
     * 用于覆盖本组件计算出的刘海高度。
     * 大部分情况下，使用者不需要传递这个属性，但是在半屏webview中，
     * 由于页面并不会接触到刘海区域，需要给paddingTopOverride传递0，
     * 来消除顶部的空白区域。
     */
    paddingTopOverride: {
      type: Number,
      default: function _default() {
        return undefined;
      }
    },
    fadeInRange: {
      type: Number,
      default: 0 // 渐现变化的范围
    },

    openThrottle: {
      type: Boolean,
      default: true // 开启scroll 节流
    }
  },
  data: function data() {
    return {
      fageBackground: '',
      opacityValue: 0
    };
  },
  computed: {
    height: function height() {
      if (this.needHideHead && this.keepPosition) {
        return this.headerHeight + "px";
      }
    },
    paddingTop: function paddingTop() {
      if (this.needHideHead) {
        var isPaddingTopOverrideUndef = this.paddingTopOverride === undefined || this.paddingTopOverride === null;
        // 让使用者可以通过 paddingTopOverride 属性来覆盖 paddingTop 的值。
        return isPaddingTopOverrideUndef ? this.htmlPaddingTop + "px" : this.paddingTopOverride + "px";
      }
    },
    scrollFadeRange: function scrollFadeRange() {
      if (this.fadeInRange) {
        return this.fadeInRange;
      } else {
        return this.headerHeight;
      }
    }
  },
  updated: function updated() {
    this.headerHeight = this.enableClientRect ? this.$refs['fix-top'].getBoundingClientRect().height : this.$refs['fix-top'].clientHeight;
  },
  mounted: function mounted() {
    this.headerHeight = this.enableClientRect ? this.$refs['fix-top'].getBoundingClientRect().height : this.$refs['fix-top'].clientHeight;
    if (this.enableFadeIn) {
      this.fageBackground = this.transferColorRgb(this.headerTaskbarBG);
      if (this.openThrottle) {
        this.$throttleFunc = this.throttleFunc(this.scrollChange, 100, 200);
        window.addEventListener('scroll', this.$throttleFunc);
      } else {
        window.addEventListener('scroll', this.scrollChange);
      }
    }
  },
  destroyed: function destroyed() {
    if (this.openThrottle) {
      window.removeEventListener('scroll', this.$throttleFunc);
    } else {
      window.removeEventListener('scroll', this.scrollChange);
    }
  },
  methods: {
    scrollChange: function scrollChange() {
      var scrollTop = Math.abs(window.scrollY || document.documentElement.scrollTop || document.body.scrollTop);
      var opacityValue = (scrollTop - this.fadeInStart) / this.scrollFadeRange;
      opacityValue = opacityValue > 1 ? 1 : opacityValue;
      this.opacityValue = opacityValue;
    },
    transferColorRgb: function transferColorRgb(sColor) {
      sColor = sColor.toLowerCase();
      // 十六进制颜色值的正则表达式
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 如果是16进制颜色
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = '#';
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        // 处理六位的颜色值
        var sColorChange = [];
        for (var _i = 1; _i < 7; _i += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(_i, _i + 2), 16));
        }
        return "" + sColorChange.join(',');
      }
      return sColor;
    },
    // 滚动节流
    throttleFunc: function throttleFunc(func, wait, mustRun) {
      var _arguments = arguments,
        _this = this;
      var timeout;
      var startTime = Number(new Date());
      return function () {
        var context = _this;
        var args = _arguments;
        var curTime = Number(new Date());
        clearTimeout(timeout);
        // 如果达到了规定的触发时间间隔，触发 handler
        if (curTime - startTime >= mustRun) {
          func.apply(context, args);
          startTime = curTime;
          // 没达到触发间隔，重新设定定时器
        } else {
          timeout = setTimeout(func, wait);
        }
      };
    }
  },
  render: function render(h) {
    var needHideHead = this.needHideHead,
      headerTaskbarBG = this.headerTaskbarBG,
      zIndex = this.zIndex,
      enableFadeIn = this.enableFadeIn,
      fageBackground = this.fageBackground,
      opacityValue = this.opacityValue;
    /**
     * background paddingTop zIndex
     */

    return h("div", {
      "style": {
        height: this.height
      }
    }, [h("div", {
      "ref": "fix-top",
      "class": bem({
        fixed: needHideHead
      }),
      "style": Object.assign({
        background: enableFadeIn ? "rgba(" + fageBackground + "," + opacityValue + ")" : headerTaskbarBG,
        paddingTop: this.paddingTop,
        zIndex: zIndex
      }, this.headerTaskbarStyle)
    }, [this.$scopedSlots.default && this.$scopedSlots.default({
      opacity: {
        opacity: opacityValue
      }
    })])]);
  }
});
exports.default = _default2;